<script setup>
</script>

<template>
    <Transition name="transition-slide-down" mode="out-in">
        <slot></slot>
    </Transition>
</template>

<style lang="scss">
@use "@bam/scss" as *;

:root {
    --duration-appear: 250ms;
    --duration-disappear: 200ms;
    --easing-accelerate: cubic-bezier(0.4, 0, 1, 1);
    --easing-decelerate: cubic-bezier(0.4, 0, 0.2, 1);
    --transition-appear: var(--duration-appear) var(--easing-decelerate);
    --transition-disappear: var(--duration-disappear) var(--easing-accelerate);
}

.transition-slide-down {
    &-enter-active {
        transition:
            transform var(--transition-appear),
            opacity var(--transition-appear);
    }

    &-leave-active {
        transition: transform var(--transition-disappear),
            opacity var(--transition-disappear);
    }

    &-enter-from,
    &-leave-to {
        transform: translateY(-100%);
        opacity: 0;
    }

    &-enter-to,
    &-leave-from {
        transform: translateY(0%);
        opacity: 1;
    }
}
</style>
